import { environment, SERVER_URL } from "src/environments/environment";
export interface AuthToken {
    access_token: string;
    expires_in: number;
    id_token: string;
    'not-before-policy': number;
    refresh_expires_in: number;
    refresh_token: string;
    scope: string;
    session_state: string;
    token_type: string;

    [key: string]: any;
}
export class Comparator {
    constructor() {
    }

    static isEmpty(obj: any): boolean {
        return obj == null || Object.keys(obj).length === 0;
    }

    static isNumberNullOrZero(obj: number): boolean {
        return obj == null || obj === 0;
    }

 

    static isStringEmpty(str: string): boolean {
        return !str || 0 === str.length;
    }

    static isStringBlank(str: string): boolean {
        return !str || /^\s*$/.test(str);
    }

    static isBiggerThanZero(num: any): boolean {
        return Comparator.isNumber(num) && num > 0;
    }

    static isNumber(num: any): boolean {
        return (num != null && true && !isNaN(parseFloat(num)) && isFinite(num));
    }

    static hasElements(obj: any[]): boolean {
        return !this.isEmpty(obj) && obj.length > 0;
    }
}
export interface IDTokenDecoded {
    jti: string;
    exp: number;
    nbf: number;
    iat: number;
    iss: string;
    aud: string;
    sub: string;
    typ: string;
    azp: string;
    nonce: string;
    auth_time: number;
    session_state: string;
    acr: string;
    email_verified: boolean;
    name: string;
    preferred_username: string;
    given_name: string;
    family_name: string;
    email: string;
    avatarUrl: string;
    mobileNumber: string;
    description: string;

    [key: string]: any;
}

export interface AuthToken {
    access_token: string;
    expires_in: number;
    id_token: string;
    'not-before-policy': number;
    refresh_expires_in: number;
    refresh_token: string;
    scope: string;
    session_state: string;
    token_type: string;

    //[key: string]: any;
}
export class Resources {
  static get Constant(): any {
    return {
      LOGIN: {
        STATE: {
          TOKEN_EXPIRED: "token_expired",
          TOKEN_OK: "token_ok",
          NO_TOKEN: "no_token"
        },
        LOGINERRORS: {
          invalid_user: "Nom d'utilisateur ou mot de passe invalide",
          missing_parameter: "Nom d'utilisateur manquant"
        }
      },
      API: {
        LOGIN: environment.keycloakConfig["url"] + environment.PleamAuthUrl,
       
        LOGOUT: environment.keycloakConfig["url"] + environment.pleamLogoutUrl,
        REINIT_PASSWORD: SERVER_URL + "/public/reinitPassword",
        RESEND_REGISTER_EMAIL: SERVER_URL + "/public/resendRegisterMail",
        REGISTER: SERVER_URL + "/public/register",
      },
      TIME_OUT: {
        LOGIN: 10000,
        CURRENT_LOCATION: 10000
      }
    };
  }
}
